/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ConversationListUpdatedPayloadSideEffectType } from "./ConversationListUpdatedPayloadSideEffectType";

export interface ConversationListUpdatedPayload {
  side_effect_type: ConversationListUpdatedPayloadSideEffectType;
}
